module.exports = __webpack_public_path__ + "img/question.bbdcac06.svg";